(function($) {
  // Site title
  $(function($){
    $('form.wpcf7-form #acceptance').after('<label for="acceptance" class="glyphicon"></label>');
    if($('[name=inquiry_type]').val() !== 'bike_new') {
        $('.form-store').hide();
    }
  });
})(jQuery);
